// componentState.svelte.js
const defaults = {
   alpha: 5,
   gamma: 1,
   threshold: 0,
   rule: 'hard',
   limType: 'classic'
};

export const daState = $state({ ...defaults });

export function resetMyState() {
  Object.assign(daState, defaults);
}


